<div class="form-row">
    <div *ngIf="showWidth" class="form-group mb-20">
        <div class="col-xs-12">
            <label>
                <span [tooltip]="'beta_test_hint' | translate"
                    >{{ "control_width" | translate }} <sup class="color-danger">β</sup></span
                >
                <small
                    [tooltip]="'widget_width_hint' | translate"
                    class="sp-icon icon-info-bold color-light"
                    style="margin-left: 5px"
                >
                </small>
            </label>
            <div>
                <sp-input-num suffixText="%" [value]="width" (valueChange)="onWidthChange($event)"></sp-input-num>
            </div>
        </div>
    </div>
    <div class="form-group mb-10">
        <label class="col-xs-12">
            <span [tooltip]="'beta_test_hint' | translate"
                >{{ "control_postiton" | translate }} <sup class="color-danger">β</sup></span
            >
        </label>
        <div class="col-xs-6">
            <div>
                <sp-input-num
                    prefixText="X"
                    suffixText="px"
                    [value]="positionX"
                    (valueChange)="onPositionXChange($event)"
                ></sp-input-num>
            </div>
        </div>

        <div class="col-xs-6">
            <div>
                <sp-input-num
                    prefixText="Y"
                    suffixText="px"
                    [value]="positionY"
                    (valueChange)="onPositionYChange($event)"
                ></sp-input-num>
            </div>
        </div>
    </div>

    <div class="form-group mb-20">
        <div class="col-xs-6">
            <div>
                <sp-input-num
                    prefixText="Z-index"
                    [max]="10"
                    [value]="zIndex"
                    (valueChange)="onZIndexChange($event)"
                ></sp-input-num>
            </div>
        </div>

        <div class="col-xs-6">
            <div>
                <sp-input-num
                    prefixText="Rot.°"
                    [value]="rotation"
                    (valueChange)="onRotationChange($event)"
                ></sp-input-num>
            </div>
        </div>
    </div>
</div>
